
require('../linkh2s');
require('../drawing-elements/customize-polygons').setup();

